import { FormControl, TextField, MenuItem } from "@mui/material";
import { ChangeEventHandler, useEffect, useState } from "react";

interface CancellationCalculatorSelectProps {
  id: string;
  value?: string;
  label: string;
  onChange: ChangeEventHandler;
  items?: { text: string; value: number }[];
}

const RefundCalculatorSelect = ({
  id,
  value,
  label,
  onChange,
  items,
}: CancellationCalculatorSelectProps) => {
  return (
    <FormControl fullWidth>
      <TextField
        select
        label={label}
        value={value}
        defaultValue={""}
        name={id}
        onChange={onChange}
        css={textFieldCSS}
      >
        {items?.map(({ value, text }) => (
          <MenuItem key={value + text} value={value}>
            {text}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

const textFieldCSS = {
  "& .MuiInputLabel-outlined": {
    color: "white",
  },
  "& .MuiOutlinedInput-root": {
    color: "white",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
      borderWidth: "1px",
    },
  },
  "& .MuiSvgIcon-root": {
    color: "white",
  },
};

export default RefundCalculatorSelect;
